import { tabletBreakpoint } from 'react-components'
import styled from 'styled-components'

export const PillFilterContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    @media only screen and (max-width: ${tabletBreakpoint.min}px) {
        padding-bottom: 1rem;
    }
`
